
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {editCarInfoDetail, getCarBrand, getCarInfoDetail, getOrderCarRepairunit, menuList, getBasicsetTotalList} from "@/api/shenghuiHttp";
export default defineComponent({
    name: "ExpireEdit",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["到期提醒"]);
        let loading = ref(false),
            Route = useRoute(),
            Router = useRouter(),
            save_car_id = ref('') as any,
            form = ref({
                id: "",
                vin: "",
                units_id: "",
                name: "",
                master_name:"",
                car_master_phone:"",
                idCard: "",
                nmtime: "",
                nm_time_text:"",
                aidue_text:"",
                ccidue_text:"",
                aidue: "",
                ccidue: "",
                cipnumber: "",
                cicompany_id: "",
                compulsory_insurance_due: "",
                jicompany_id: "",
                dipolicy_no: "",
                body_color: "",
                engine_number: "",
                purchase_time: "",
                maintenance_mileage: "",
                phone: "",
                tips: "",
                car_brand_id:"",
                car_series_id:"",
                purchase_time_text:"",
                compulsory_insurance_due_text:""
            }),
            formRef = ref(null),
            repairunitData = ref([]),
            cicompanyData = ref([]),
            car_brand_data = ref([]),
            car_series_data = ref([]),
            getTableData = (): void => {
                menuList({
                    id: Route.query.id,
                }).then((res: any) => {
                    form.value = res?.content?.list || {};
                });
            },
            selectCarBrandChange = (() => {
                getCarBrand({
                    brand_id: Number(form.value.car_brand_id),
                }).then((res: any) => {
                    car_series_data = res?.content?.list || [];
                    form.value.car_series_id = "";
                });
            }),
            saveCarInfoChange = (e: any, key: string) => {
                if (key == "nmtime" || key == "aidue" || key == "ccidue" || key == "purchase_time" || key == "compulsory_insurance_due") {
                    if (e) {
                        e = new Date(e).getTime() / 1000;
                        form.value[key] = e;
                    } else {
                        form.value[key] = "";
                    }
            
                }
            },
            onSubmit = () => {
                editCarInfoDetail({...form.value,car_id:form.value.id}).then((res:any)=>{
                    if (res.status == 202) {
                        Router.back();
                    }
                });
            };

        onMounted(() => {
            let id: any = useRoute().query.id;
            save_car_id = useRoute().query.id;
            loading.value = true;
            getCarInfoDetail({car_id:id}).then((res:any)=>{
                loading.value = false;
                form.value = res.content.list;
                getCarBrand({brand_id: form.value.car_brand_id}).then((res: any) => {
                    car_series_data.value =
                        res?.content?.list || [];
                });
            });
            // 保险公司
            getBasicsetTotalList({
                basicset_type: 9,
            }).then((res: any) => {
                cicompanyData.value = res?.content?.list || [];
            });
            
            getCarBrand({}).then((res: any) => {
                car_brand_data.value = res?.content?.list || [];
            });
            // 所属单位
            getOrderCarRepairunit({}).then((res: any) => {
                repairunitData.value = res?.content?.list || [];
            });
        });

        return {
            loading,
            form,
            formRef,
            onSubmit,
            cicompanyData,
            repairunitData,
            car_brand_data,
            selectCarBrandChange,
            car_series_data,
            saveCarInfoChange
        };
    },
});
